import { __decorate } from "tslib";
import { ApiResource } from '../../lib/api-decorators';
import { Api } from '../../lib/api.factory';
let ItemResource = class ItemResource extends Api {
    create(item, files) {
        return this.post('/', item, files);
    }
    update(item, files) {
        return this.put(`/${item.id}`, item, files);
    }
    updateStatus(itemId, status, reportDate) {
        return this.put(`/status/${itemId}`, { status, reportDate });
    }
    remove(itemId) {
        return this.delete(`/${itemId}`);
    }
    getItemCountOnQueue(project, category) {
        return this.get('/queue-count', { project, category });
    }
    getSourcesWithCandidateItemCounts(project, category) {
        return this.get('/source-counts', { project, category });
    }
    getList(params) {
        return this.get('/list', params);
    }
    getItemUpdatedAt(project, category, source) {
        return this.get('/updatedat', { project, category, source });
    }
    getBatch(itemIds) {
        return this.get('/batch', { items: itemIds });
    }
    getOldItemForReport(project, url) {
        return this.get('/old-report-item', { project, url });
    }
};
ItemResource = __decorate([
    ApiResource('/item')
], ItemResource);
export { ItemResource };
